import JSCookies from 'js-cookie';

const LOGIN_PATH = '/Login';

export const clearAuthStorage = () => {
	localStorage.removeItem('token');
	localStorage.removeItem('userData');
	localStorage.removeItem('user');
	localStorage.removeItem('role');
	localStorage.removeItem('subscriptionId');
	sessionStorage.clear();
	JSCookies.remove('token');
	JSCookies.remove('user');
	document.cookie = 'token=; Max-Age=0; path=/;';
	document.cookie = 'user=; Max-Age=0; path=/;';
};

export const redirectToLoginForAuthFailure = () => {
	console.error('[redirectToLoginForAuthFailure] called from:', new Error().stack);
	clearAuthStorage();

	if (window.location.pathname.toLowerCase() !== LOGIN_PATH.toLowerCase()) {
		window.location.replace(LOGIN_PATH);
	}
};
